import { render, staticRenderFns } from "./traveler-label.vue?vue&type=template&id=c35093c6&scoped=true"
import script from "./traveler-label.vue?vue&type=script&lang=js"
export * from "./traveler-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35093c6",
  null
  
)

export default component.exports